module.exports = __webpack_public_path__ + "static/img/3.f8ce878.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/hearthstone/ranks/3.png
// module id = n2jm
// module chunks = 35